<template>
    <div>
      <div class="banner">
        <div class="headerReplacementInformation"></div>
        <div class="banner-text">
          <b>{{ $t('receiveEmails.title') }}</b>
          <div class="breadcrumb">
            <span><router-link to="/" class="pe-auto">{{ $t('receiveEmails.home') }}</router-link></span>
            <span class="separator"></span>
            <span>{{ $t('receiveEmails.breadcrumb') }}</span>
            <span class="separator"></span>
            <span><b>{{ $t('receiveEmails.title') }}</b></span>
          </div>
        </div>
      </div>
  
      <div class="container mb-5">
        <div class="TabMenu mb-5">
          <InformationTabMenu />
        </div>
  
        <div class="text-center mb-5">
          <h4 class="fw-bold">{{ $t('receiveEmails.description1') }}</h4>
          <div>{{ $t('receiveEmails.description2') }}</div>
          <div>{{ $t('receiveEmails.description3') }}</div>
        </div>
  
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="card border border-0 rounded-0 p-3">
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md">
                    <label class="form-label">{{ $t('receiveEmails.fullName') }}</label>
                    <input v-model="form.fullName" type="text" class="form-control" :placeholder="$t('receiveEmails.placeholder.fullName')" />
                    <span v-if="errorMessage.fullName" class="text-danger">{{ errorMessage.fullName }}</span>
                  </div>
                  <div class="col-md">
                    <label class="form-label">{{ $t('receiveEmails.email') }}</label>
                    <input v-model="form.email" type="email" class="form-control" :placeholder="$t('receiveEmails.placeholder.email')" />
                    <span v-if="errorMessage.email" class="text-danger">{{ errorMessage.email }}</span>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md">
                    <label class="form-label">{{ $t('receiveEmails.country') }}</label>
                    <input v-model="form.country" type="text" class="form-control" :placeholder="$t('receiveEmails.placeholder.country')" />
                    <span v-if="errorMessage.country" class="text-danger">{{ errorMessage.country }}</span>
                  </div>
                  <div class="col-md">
                    <label class="form-label">{{ $t('receiveEmails.occupation') }}</label>
                    <input v-model="form.occupation" type="text" class="form-control" :placeholder="$t('receiveEmails.placeholder.occupation')" />
                    <span v-if="errorMessage.occupation" class="text-danger">{{ errorMessage.occupation }}</span>
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-md">
                    <label class="form-label">{{ $t('receiveEmails.jobTitle') }}</label>
                    <input v-model="form.jobTitle" type="text" class="form-control" :placeholder="$t('receiveEmails.placeholder.jobTitle')" />
                    <span v-if="errorMessage.jobTitle" class="text-danger">{{ errorMessage.jobTitle }}</span>
                  </div>
                  <div class="col-md">
                    <label class="form-label">{{ $t('receiveEmails.industry') }}</label>
                    <input v-model="form.industry" type="text" class="form-control" :placeholder="$t('receiveEmails.placeholder.industry')" />
                    <span v-if="errorMessage.industry" class="text-danger">{{ errorMessage.industry }}</span>
                  </div>
                </div>
                <div class="d-grid gap-2 col-4 mx-auto">
                  <button @click="subscribeToEmails" class="btn btn-primary" type="button">
                    {{ $t('receiveEmails.subscribe') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="text-center mt-5">
          {{ $t('receiveEmails.unsubscribePrompt') }}
          <span @click="openModal" class="text-reemail">{{ $t('receiveEmails.unsubscribeHere') }}</span>
        </div>
  
        <div v-if="showModal" class="modal fade show" tabindex="-1" style="display: block;" aria-modal="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="text-center m-3">
                  <h5>{{ $t('receiveEmails.modalTitle1') }}</h5>
                  <h5>{{ $t('receiveEmails.modalTitle2') }}</h5>
                </div>
                <div class="text-center m-3">
                  <small>{{ $t('receiveEmails.modalInstruction') }}</small>
                </div>
                <label class="form-label">{{ $t('receiveEmails.email') }}</label>
                <input v-model="modalEmail" type="email" class="form-control" :placeholder="$t('receiveEmails.placeholder.email')" />
                <span v-if="errorMessage.modalEmail" class="text-danger">{{ errorMessage.modalEmail }}</span>
                <div class="text-center m-3">
                  <button type="button" class="m-1 btn btn-primary" @click="unsubscribeEmail">
                    {{ $t('receiveEmails.unsubscribe') }}
                  </button>
                  <button type="button" class="m-1 btn btn-secondary" @click="closeModal">
                    {{ $t('receiveEmails.close') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
<script>
import InformationTabMenu from '@/components/InformationTabMenu.vue';
import { GET_RECEIVE_EMAIL_INVESTOR, GET_CANCEL_EMAIL_INVESTOR } from "../../store/actions.type";
import store from "@/store";
import Swal from "sweetalert2/src/sweetalert2.js";

export default {
    name: 'Info',
    components: { InformationTabMenu },
    data() {
        return {
            form: {
                fullName: '', email: '', country: '', occupation: '', jobTitle: '', industry: ''
            },
            errorMessage: {},
            showModal: false,
            modalEmail: '',
        };
    },
    methods: {
        validateForm(form) {
            let errors = {};
            if (!form.fullName) errors.fullName = this.$t('receiveEmails.errorFullName');
            if (!form.email || !/\S+@\S+\.\S+/.test(form.email)) errors.email = this.$t('receiveEmails.errorEmail');
            if (!form.country) errors.country = this.$t('receiveEmails.errorCountry');
            if (!form.occupation) errors.occupation = this.$t('receiveEmails.errorOccupation');
            if (!form.jobTitle) errors.jobTitle = this.$t('receiveEmails.errorJobTitle');
            if (!form.industry) errors.industry = this.$t('receiveEmails.errorIndustry');
            return Object.keys(errors).length > 0 ? errors : null;
        },

        async subscribeToEmails() {
            let errorMessage = this.validateForm(this.form);
            if (errorMessage) return this.errorMessage = errorMessage;
            this.errorMessage = {};
            try {
                let response = await store.dispatch(GET_RECEIVE_EMAIL_INVESTOR, this.form);
                if (response === 'Subscription request sent successfully') {
                    Swal.fire({ text: this.$t('receiveEmails.success'), icon: 'success', confirmButtonColor: '#E87D2E' });
                    this.form = {};
                } else {
                    Swal.fire({ text: this.$t('receiveEmails.fail'), icon: 'error', confirmButtonColor: '#E87D2E' });
                }
            } catch {
                Swal.fire({ text: this.$t('receiveEmails.error'), icon: 'error', confirmButtonColor: '#E87D2E' });
            }
        },

        openModal() { this.showModal = true; },
        closeModal() { this.showModal = false; },

        unsubscribeEmail() {
            if (!this.modalEmail || !/\S+@\S+\.\S+/.test(this.modalEmail)) {
                this.errorMessage.modalEmail = this.$t('receiveEmails.errorEmail');
                return;
            } else this.errorMessage.modalEmail = '';
            const form = { email: this.modalEmail };
            store.dispatch(GET_CANCEL_EMAIL_INVESTOR, form).then(response => {
                if (response === 'Unsubscription request sent successfully') {
                    Swal.fire({ text: this.$t('receiveEmails.unsubSuccess'), icon: 'success', confirmButtonColor: '#E87D2E' });
                    this.modalEmail = ''; this.closeModal();
                } else {
                    Swal.fire({ text: this.$t('receiveEmails.unsubFail'), icon: 'error', confirmButtonColor: '#E87D2E' });
                }
            }).catch(() => {
                Swal.fire({ text: this.$t('receiveEmails.error'), icon: 'error', confirmButtonColor: '#E87D2E' });
            });
        }
    }
};
</script>
<style scoped>
.text-reemail {
    color: #E87D2E;
    cursor: pointer;
}

h2.mt-5 {
    display: inline-block;
    border-bottom: 3px solid #E87D2E;
    padding-bottom: 5px;
}

.card-pdf {
    box-shadow: 0px 4px 10px 0px #0000000D;
    border: none;
}

.card {
    background-color: #F2F2F2;
}

.vertical-line {
    width: 4px;
    background-color: #E87D2E;
    margin-left: 30px;
    height: 40%;
    margin-top: 10px;
}

th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.text-danger {
    font-size: 12px;
    color: red;
}

.modal {
    z-index: 1050;
    /* Ensure modal is on top */
}</style>
